<template>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M9.925 8.21A1.714 1.714 0 0 1 8.21 9.926H1.714v4.15h6.497a1.715 1.715 0 0 1 1.714 1.714v6.497h4.15v-6.497a1.715 1.715 0 0 1 1.714-1.714h6.497v-4.15h-6.497a1.714 1.714 0 0 1-1.714-1.714V1.714h-4.15v6.497ZM8.21 1.264A1.263 1.263 0 0 1 9.474 0h5.052a1.264 1.264 0 0 1 1.263 1.263v6.948h6.948A1.264 1.264 0 0 1 24 9.474v5.052a1.263 1.263 0 0 1-1.263 1.263h-6.948v6.948A1.264 1.264 0 0 1 14.526 24H9.474a1.263 1.263 0 0 1-1.263-1.263v-6.948H1.263A1.264 1.264 0 0 1 0 14.526V9.474a1.263 1.263 0 0 1 1.263-1.263h6.948V1.263Z"
    clip-rule="evenodd"
  />
</template>
